
<div
  class="flex overflow-x-hidden pt-8 pb-16 lg:pt-28 lg:pb-0 font-rubik bg-themeComponentBg-light"
  ref="scrollContainer"
  @mouseenter="pauseScroll"
  @mouseleave="resumeScroll"
>
  <div
    v-for="(imageSet, setIndex) in duplicatedImageSets"
    :key="setIndex"
    class="flex items-center flex-shrink-0 gap-2 lg:gap-4 pr-4 lg:pr-4"
  >
    <div class="flex-shrink-0">
      <div
        v-if="imageSet[0]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[198px] h-[332px] lg:w-[316px] lg:h-[475px]"
      >
        <img :src="imageSet[0].primary_photo" alt="">
      </div>
    </div>
    <div class="flex flex-col flex-shrink-0 gap-2 lg:gap-4">
      <div
        v-if="imageSet[1]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[108px] h-[108px] lg:w-[216px] lg:h-[216px]"
      >
        <img :src="imageSet[1].primary_photo" alt="">
      </div>
      <div
        v-if="imageSet[2]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[108px] h-[108px] lg:w-[216px] lg:h-[216px]"
      >
        <img :src="imageSet[2].primary_photo" alt="">
      </div>
    </div>
    <div class="flex-shrink-0">
      <div
        v-if="imageSet[3]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[144px] h-[193px] lg:w-[316px] lg:h-[316px]"
      >
        <img :src="imageSet[3].primary_photo" alt="">
      </div>
    </div>
    <div class="flex-shrink-0">
      <div
        v-if="imageSet[4]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[216px] h-[362px] lg:w-[432px] lg:h-[724px]"
      >
        <img :src="imageSet[4].primary_photo" alt="">
      </div>
    </div>
    <div class="flex-shrink-0">
      <div
        v-if="imageSet[5]"
        class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[158px] h-[211px] lg:w-[316px] lg:h-[422px]"
      >
        <img :src="imageSet[5].primary_photo" alt="">
      </div>
    </div>
  </div>
</div>
